import { Image, Flex, Text, Center, Divider, Spacer, Link } from "@chakra-ui/react";
import React, { memo } from "react";
import { FaTwitter } from "react-icons/fa";
export default memo(function BottomComponent() {
   return (
      <>
         <Image userSelect={"none"} src={process.env.REACT_APP_PUBLIC_URL + "images/bottom_bg.png"} />
         <Center bg="#EFF7FA" mt="-2px" pt="24px" pb="84px">
            <Flex flexDir={"column"} width={"1280px"} marginX={"auto"}>
               <Image
                  userSelect={"none"}
                  className="refImg"
                  w={128}
                  h={34}
                  data-src={process.env.REACT_APP_PUBLIC_URL + "iconfont/logo_icon.svg"}></Image>
               <Flex mt="18px" alignItems={"center"}>
                  <Text fontSize={18}>© 2022 AlohaBots</Text>
                  <Divider color="#ccc" orientation="vertical" mx={"20px"} height={"20px"} />
                  <Text fontSize={18}>Service@AlohaBots.xyz</Text>
                  <Spacer />
                  <Link
                     href={"/doc/termsofservice"}
                     isExternal
                     _focus={{ boxShadow: "none" }}
                     style={{ textDecoration: "none" }}>
                     <Text fontSize={18} _hover={{ color: "green.500" }} cursor={"pointer"}>
                        Terms of Service
                     </Text>
                  </Link>
                  <Divider orientation="vertical" h={"20px"} mx={"20px"} />

                  <Link
                     href={"/doc/privacy"}
                     mr={"60px"}
                     isExternal
                     _focus={{ boxShadow: "none" }}
                     style={{ textDecoration: "none" }}>
                     <Text fontSize={18} _hover={{ color: "green.500" }} cursor={"pointer"}>
                        Privacy Policy
                     </Text>
                  </Link>
                  <Link
                     href="https://twitter.com/Aloha_Bots"
                     _hover={{ color: "blue.500" }}
                     isExternal
                     _focus={{ boxShadow: "none" }}>
                     <FaTwitter cursor={"pointer"} size={"26px"} />
                  </Link>
               </Flex>
            </Flex>
         </Center>
      </>
   );
});
